// https://wicg.github.io/serial/#dom-serialport-readable
export class LineBreakTransformer {
    private container: string;
    private separator: string;

    constructor(separator: string = '\r\n') {
        this.container = '';
        this.separator = separator;
    }

    // LD5204 Bečej Novi     \r
    // MX100 Rumenka         \r\n
    transform(chunk: string, controller: { enqueue: (arg0: string) => void; }) {
        this.container += chunk;
        const lines = this.container.split(this.separator);
        this.container = lines.pop() as string;
        lines.forEach(line => controller.enqueue(line));
    }

    flush(controller: { enqueue: (arg0: string | undefined) => void; }) {
        controller.enqueue(this.container);
    }
}
